import { get, post, put } from "../Config";

export function SearchSegmentation({ params }) {
  return get({ url: `/api/hu/v1/segmentation`, params });
}
export function GetSegmentationById({ id }) {
  return get({ url: `/api/hu/v1/segmentation/${id}` });
}
export function CreateSegmentation({ params, data }) {
  return post({ url: `/api/hu/v1/segmentation/create`, params, data });
}
export function UpdateSegmentation({ params, data }) {
  return post({ url: `/api/hu/v1/segmentation/update`, params, data });
}
export function DeleteSegmentation({ params, data }) {
  return post({ url: `/api/hu/v1/segmentation/delete`, params, data });
}
export function InputformSegmentation({ params }) {
  return get({ url: `/api/hu/v1/inputform/segmentation`, params });
}

export function ExportSegmentationById({ id }) {
  return get({ url: `/api/hu/v1/segmentation/export/${id}`, timeOut: 9999999 });
}
export function ReloadSegmentationById({ id }) {
  return get({ url: `/api/hu/v1/segmentation/reload/${id}`, timeOut: 9999999 });
}